import { render, staticRenderFns } from "./BaseOfficeViewer.vue?vue&type=template&id=1fbb09bc&"
import script from "./BaseOfficeViewer.vue?vue&type=script&lang=js&"
export * from "./BaseOfficeViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fbb09bc')) {
      api.createRecord('1fbb09bc', component.options)
    } else {
      api.reload('1fbb09bc', component.options)
    }
    module.hot.accept("./BaseOfficeViewer.vue?vue&type=template&id=1fbb09bc&", function () {
      api.rerender('1fbb09bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseOfficeViewer.vue"
export default component.exports